
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20.64","height":"18.122"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"gallery (1)"}},[_c('g',{attrs:{"data-name":"Group 66005"}},[_c('g',{attrs:{"data-name":"Group 66004","fill":"#fff","stroke":"#fff","stroke-width":".3"}},[_c('path',{attrs:{"data-name":"Path 8540","d":"M10.446 6.442a2.074 2.074 0 102.074 2.074 2.074 2.074 0 00-2.074-2.074zm0 3.16a1.087 1.087 0 110-2.173h0a1.087 1.087 0 010 2.173z"}}),_c('path',{attrs:{"data-name":"Path 8541","d":"M18.716 1.702L5.236.171a1.851 1.851 0 00-1.457.42 1.876 1.876 0 00-.715 1.286l-.247 2.024H2.05a1.984 1.984 0 00-1.9 2.047v10.1a1.876 1.876 0 001.826 1.925h13.63a2.027 2.027 0 002.074-1.926v-.4a2.469 2.469 0 00.938-.4 2.049 2.049 0 00.716-1.333L20.47 3.89a2 2 0 00-1.754-2.188zm-2.024 14.344a1.04 1.04 0 01-1.086.938H2.05a.889.889 0 01-.914-.862v-1.903l3.827-2.814a1.185 1.185 0 011.531.074l2.691 2.37a2.321 2.321 0 001.457.543 2.247 2.247 0 001.185-.321l4.864-2.814v4.79zm0-5.95l-5.382 3.135a1.259 1.259 0 01-1.46-.123l-2.713-2.395a2.2 2.2 0 00-2.74-.1l-3.259 2.372V5.948a1 1 0 01.912-1.061h13.556a1.136 1.136 0 011.086 1.062v4.148zm2.791-6.33v.01L18.323 13.8a.839.839 0 01-.321.667c-.1.1-.321.148-.321.2V5.948a2.123 2.123 0 00-2.074-2.049H3.804l.223-1.922a1.136 1.136 0 01.37-.642 1.136 1.136 0 01.741-.2L18.593 2.69a.988.988 0 01.89 1.076z"}})])])])])
          )
        }
      }
    